//
import CredencialesMachine from "./machine"
import { actionsNoCare } from "../../constants/actionsNoCare"
export const { initialState } = CredencialesMachine

const Credenciales = (state = initialState, action) => {
  //
  if (
    !actionsNoCare.includes(action.type) &&
    !action.type.startsWith("@@") &&
    action.type.startsWith("CREDENCIALES/")
  ) {
    if (!CredencialesMachine.states[state.value]?.on?.[action.type]) {
      console.error(
        `CredencialesMachine: No hay transición definida para la acción ${action.type} en el estado ${state.value}`
      )
    } else {
      return CredencialesMachine.transition(state, action)
    }
  }
  return state
}

export default Credenciales
